import { inject, observer } from 'mobx-react';
import React from 'react';
import { IInjectedRootStore, RequiredFeatures } from 'stores';

interface IFeatureRequiredProps {
    requires: RequiredFeatures;
    children: React.ReactElement | React.ReactElement[];
}

@inject('rootStore')
@observer
export class FeatureRequired extends React.Component<IFeatureRequiredProps> {
    public render(): React.ReactElement | React.ReactElement[] {
        const { children } = this.props;
        return this.isAllowed ? children : <></>;
    }
    private get injected(): IInjectedRootStore {
        return this.props as IFeatureRequiredProps & IInjectedRootStore;
    }
    private get isAllowed(): boolean {
        switch (this.props.requires) {
            case 'DEV':
                return this.injected.rootStore.isDev();
            case 'ADMIN':
                return this.injected.rootStore.isAdmin();
            default:
                return true;
        }
    }
}
